export default (state = false, action) => {
  switch (action.type) {
    case 'loadUserData':
      return true
    default:
      return state
  }
}
